import React, { useState } from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import FeatureManifestDetail from '../../components/FeatureManifestDetail/FeatureManifestDetail';
import SpecManifestDetail from '../../components/SpecManifestDetail/SpecManifestDetail';
import { getAlignerByIDForAlignerPage   } from '../../api/GetAlignerByIDForAlignerPage';
import { TNtfyNew} from '../../_types/ntfy';
import { NtfyReport } from '../../features/store/ntfy.slice';
import { useDispatch } from 'react-redux';
import { useAuth0} from '@auth0/auth0-react';
import SearchIcon from '@mui/icons-material/Search';

const Manifest = () => {
  const [serialNumber, setSerialNumber] = useState('');
  const [equipmentSerialNumber, setEquipmentSerialNumber] = useState('');
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch<any>();

  const onEquipmentSerialNumberChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setEquipmentSerialNumber(event.target.value.toUpperCase());
  }

  const onEquipmentSerialNumberKeyPress = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', 'NumpadEnter'].includes(event.key)) {
      try {
        const token = await getAccessTokenSilently();
        await getAlignerByIDForAlignerPage(equipmentSerialNumber, token);
        setSerialNumber(equipmentSerialNumber);
      } catch (err: any) {
        const notification = TNtfyNew(
          err.message,
          'error',
          'long',
        );

        dispatch(NtfyReport(notification));
        setSerialNumber('');
      }
    }
  }

  return (
    <Box sx={{ mt:4, mx:3 }}>
      <TextField
        id="outlined-basic"
        label="Equipment Serial Number"
        variant="outlined"
        value={equipmentSerialNumber}
        onChange={onEquipmentSerialNumberChange}
        onKeyDown={onEquipmentSerialNumberKeyPress}
        fullWidth
        sx={{ maxWidth: 300 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                color="primary"
                onClick={() => setSerialNumber(equipmentSerialNumber)}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Box sx={{ mt: 2, mb: 4}}>
        <FeatureManifestDetail equipmentSerialNumber={serialNumber} />
        <SpecManifestDetail equipmentSerialNumber={serialNumber} />
      </Box>
    </Box>
  );
}

export default Manifest;
